module.exports = __webpack_public_path__ + "static/img/avatar.3028cdd7.png";